<svg
  width="25"
  height="24"
  viewBox="0 0 25 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M21.8116 11.1249L12.7896 6.12494C12.6416 6.04285 12.4751 5.99969 12.3058 5.99951C12.1364 5.99934 11.9699 6.04215 11.8216 6.12394L2.84363 11.0839C2.68742 11.1702 2.55715 11.2967 2.46633 11.4504C2.37551 11.604 2.32746 11.7791 2.32715 11.9576C2.32684 12.136 2.3743 12.3113 2.46459 12.4652C2.55488 12.6192 2.68472 12.7461 2.84063 12.8329L11.8626 17.8729C12.0112 17.9564 12.1786 18.0003 12.349 18.0005C12.5194 18.0007 12.6869 17.9571 12.8356 17.8739L21.8136 12.8739C21.9696 12.7872 22.0995 12.6603 22.1899 12.5064C22.2803 12.3526 22.3278 12.1773 22.3276 11.9989C22.3274 11.8204 22.2794 11.6453 22.1887 11.4916C22.098 11.3379 21.9678 11.2113 21.8116 11.1249ZM12.3506 15.8549L5.38663 11.9649L12.3036 8.14294L19.2676 12.0019L12.3506 15.8549Z"
    fill="#058BEB"
  />
  <path
    d="M12.3276 22C12.4974 22.0001 12.6644 21.9567 12.8126 21.874L21.8126 16.874L20.8416 15.126L12.3276 19.856L3.81261 15.126L2.84161 16.874L11.8416 21.874C11.9903 21.9566 12.1575 22 12.3276 22ZM20.3276 2H18.3276V4H16.3276V6H18.3276V8H20.3276V6H22.3276V4H20.3276V2Z"
    fill="#058BEB"
  />
</svg>
